import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circular-progress',
  templateUrl: './circular-progress.component.html',
})
export class CircularProgressComponent {
  @Input() value: string;
  @Input() growth: string;

  sign(){
    return this.percent() > 0 ? '+' : '-';
  }

  percent() {
    return Math.round(parseFloat(this.value)*100);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/circular-progress/circular-progress.component.ts